import Api from "./Api";
export default {
  getIntegrations(companyId) {
    return Api().get(`/integrations/${companyId}`);
  },
  getIntegrationJobs(companyId) {
    return Api().get(`/integration-jobs/${companyId}`);
  },
  addStoreVensafeByToken(payload) {
    return Api().post(`/vensafe-stores-by-token`, payload);
  },
  createIntegration(payload) {
    return Api().post(`/integration`, payload);
  },
};